var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#2D2926"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6612 27C27.9127 24.4363 30 20.4619 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 20.4619 4.08734 24.4363 7.3388 27H24.6612Z",
    fill: "#F5DADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6612 27V28H25.008L25.2804 27.7853L24.6612 27ZM7.3388 27L6.71965 27.7853L6.99199 28H7.3388V27ZM29 16C29 20.1427 27.0634 23.8325 24.042 26.2147L25.2804 27.7853C28.762 25.0401 31 20.7811 31 16H29ZM16 3C23.1797 3 29 8.8203 29 16H31C31 7.71573 24.2843 1 16 1V3ZM3 16C3 8.8203 8.8203 3 16 3V1C7.71573 1 1 7.71573 1 16H3ZM7.95796 26.2147C4.93664 23.8325 3 20.1427 3 16H1C1 20.7811 3.23803 25.0401 6.71965 27.7853L7.95796 26.2147ZM7.3388 28H24.6612V26H7.3388V28Z",
    fill: "#2D2926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2962 16.328H14.2922C14.3522 16.556 14.4002 16.784 14.4002 17.06C14.4002 17.96 13.7642 18.572 13.1042 19.184L13.9322 20.096C14.4122 19.82 14.7962 19.652 15.3242 19.652C16.0562 19.652 16.2842 20.096 17.1482 20.096C17.9882 20.096 18.5882 19.64 19.1282 18.692L18.0962 18.044C17.7722 18.596 17.5322 18.716 17.2322 18.716C16.6682 18.716 16.5242 18.356 15.9362 18.356C15.5042 18.356 15.0842 18.536 14.7482 18.74C15.2642 18.296 15.7202 17.78 15.7202 16.784C15.7202 16.616 15.7082 16.472 15.6842 16.328H17.3402V14.936H15.2642C15.2042 14.708 15.1682 14.444 15.1682 14.084C15.1682 13.232 15.6962 12.896 16.2362 12.896C16.8122 12.896 17.2202 13.172 17.4842 13.748L18.7202 13.16C18.3602 12.152 17.5082 11.504 16.2362 11.504C14.6762 11.504 13.6802 12.584 13.6802 14C13.6802 14.348 13.7762 14.66 13.8722 14.936H13.2962V16.328Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.7c192fa9e697ccc00157f3459deb36cd.svg";
export { ForwardRef as ReactComponent };